(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}(g.reduct || (g.reduct = {})).nitpick = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _abstractValidator = _dereq_('./abstractValidator.js');

var _abstractValidator2 = _interopRequireDefault(_abstractValidator);

var _utilities = _dereq_('./utilities/');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Applies a general check for the existence of a value.
 *
 * @param fn {*} The optional validator function which will be executed after the check.
 * @returns {Function} The curry function which will be wrapped around the validator.
 *
 */

exports.default = function (fn) {
	return (0, _abstractValidator2.default)(function (val) {
		var isValueDefined = (0, _utilities.isDefined)(val);

		if (!isValueDefined) {
			return new Error('The value is required but is either "undefined" or "null".');
		}

		return (0, _utilities.isFunction)(fn) ? fn(val) : val;
	});
};

},{"./abstractValidator.js":2,"./utilities/":12}],2:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Reduces the overall amount of code to align the @reduct/nitpick validators to the validator scheme.
 *
 * @param fn {*} The validator function which will be executed via FP.
 * @returns {Function} The curry function which will be wrapped around the validator.
 *
 */

exports.default = function (fn) {
  return function (props, propName) {
    return fn(props[propName]);
  };
};

},{}],3:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOptional = exports.isRequired = undefined;

var _abstractRequiredValidator = _dereq_('./abstractRequiredValidator.js');

var _abstractRequiredValidator2 = _interopRequireDefault(_abstractRequiredValidator);

var _abstractValidator = _dereq_('./abstractValidator.js');

var _abstractValidator2 = _interopRequireDefault(_abstractValidator);

var _utilities = _dereq_('./utilities/');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents a general required check against a value.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an Error of the passed value if defined.
 *
 */
var isRequired = exports.isRequired = (0, _abstractRequiredValidator2.default)();

/**
 * Represents a general optional check against a value.
 *
 * @param val {*} The value which will be validated.
 * @returns {*} Either an undefined or the value which was passed to the validator.
 *
 */
var isOptional = exports.isOptional = (0, _abstractValidator2.default)(function (val) {
  var isValueDefined = (0, _utilities.isDefined)(val);

  // Fail safe to have a conssitent return value
  // if "null" was passed as the value.
  if (!isValueDefined) {
    return undefined;
  }

  return val;
});

},{"./abstractRequiredValidator.js":1,"./abstractValidator.js":2,"./utilities/":12}],4:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isOptional = exports.isRequired = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _abstractRequiredValidator = _dereq_('./abstractRequiredValidator.js');

var _abstractRequiredValidator2 = _interopRequireDefault(_abstractRequiredValidator);

var _abstractValidator = _dereq_('./abstractValidator.js');

var _abstractValidator2 = _interopRequireDefault(_abstractValidator);

var _utilities = _dereq_('./utilities/');

var _any = _dereq_('./any.js');

var any = _interopRequireWildcard(_any);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extends the general required validator for the type `Boolean`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an Error of the passed value if defined.
 *
 */
var isRequired = exports.isRequired = (0, _abstractRequiredValidator2.default)(function (val) {
	var convertedBoolean = (0, _utilities.convertStringBoolean)(val);
	var isValueNotBool = !(0, _utilities.isBoolean)(convertedBoolean);

	if (isValueNotBool) {
		return new Error('The value is required and must be a "Boolean", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return convertedBoolean;
});

/**
 * Extends the general optional validator for the type `Boolean`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an error or the value which was passed to the validator.
 *
 */
var isOptional = exports.isOptional = (0, _abstractValidator2.default)(function (val) {
	var convertedBoolean = (0, _utilities.convertStringBoolean)(val);
	var isValueNotBool = !(0, _utilities.isBoolean)(convertedBoolean);

	if ((0, _utilities.isDefined)(val) && isValueNotBool) {
		return new Error('The value is optional, but must be a "Boolean", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return convertedBoolean;
});

},{"./abstractRequiredValidator.js":1,"./abstractValidator.js":2,"./any.js":3,"./utilities/":12}],5:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _any = _dereq_('./any.js');

var any = _interopRequireWildcard(_any);

var _bool = _dereq_('./bool.js');

var bool = _interopRequireWildcard(_bool);

var _number = _dereq_('./number.js');

var number = _interopRequireWildcard(_number);

var _object = _dereq_('./object.js');

var object = _interopRequireWildcard(_object);

var _string = _dereq_('./string.js');

var string = _interopRequireWildcard(_string);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
	any: any,
	bool: bool,
	number: number,
	object: object,
	string: string
};

},{"./any.js":3,"./bool.js":4,"./number.js":6,"./object.js":7,"./string.js":8}],6:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isOptional = exports.isRequired = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _abstractRequiredValidator = _dereq_('./abstractRequiredValidator.js');

var _abstractRequiredValidator2 = _interopRequireDefault(_abstractRequiredValidator);

var _abstractValidator = _dereq_('./abstractValidator.js');

var _abstractValidator2 = _interopRequireDefault(_abstractValidator);

var _utilities = _dereq_('./utilities/');

var _any = _dereq_('./any.js');

var any = _interopRequireWildcard(_any);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extends the general required validator for the type `Number`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an error or the value if it is a valid Boolean.
 *
 */
var isRequired = exports.isRequired = (0, _abstractRequiredValidator2.default)(function (val) {
	var convertedNumber = (0, _utilities.isString)(val) ? Math.abs(val) : val;
	var isNumber = (0, _utilities.isNumeric)(convertedNumber);

	if (!isNumber) {
		return new Error('The value is required and must be a "Number", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return convertedNumber;
});

/**
 * Extends the general optional validator for the type `Number`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an error or the value which was passed to the validator.
 *
 */
var isOptional = exports.isOptional = (0, _abstractValidator2.default)(function (val) {
	var convertedNumber = (0, _utilities.isString)(val) ? Math.abs(val) : val;
	var isValueNotNumeric = !(0, _utilities.isNumeric)(convertedNumber);

	if ((0, _utilities.isDefined)(val) && isValueNotNumeric) {
		return new Error('The value is optional, but must be a "Number", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return convertedNumber;
});

},{"./abstractRequiredValidator.js":1,"./abstractValidator.js":2,"./any.js":3,"./utilities/":12}],7:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isOptional = exports.isRequired = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _abstractRequiredValidator = _dereq_('./abstractRequiredValidator.js');

var _abstractRequiredValidator2 = _interopRequireDefault(_abstractRequiredValidator);

var _abstractValidator = _dereq_('./abstractValidator.js');

var _abstractValidator2 = _interopRequireDefault(_abstractValidator);

var _utilities = _dereq_('./utilities/');

var _any = _dereq_('./any.js');

var any = _interopRequireWildcard(_any);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extends the general required validator for the type `Object`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an Error of the passed value if defined.
 *
 */
var isRequired = exports.isRequired = (0, _abstractRequiredValidator2.default)(function (val) {
	// Try to convert the value to a JSON object.
	try {
		val = JSON.parse(val);
	} catch (e) {}

	if (!(0, _utilities.isObject)(val)) {
		return new Error('The value is required and must be a "Object", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return val;
});

/**
 * Extends the general optional validator for the type `Boolean`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an error or the value which was passed to the validator.
 *
 */
var isOptional = exports.isOptional = (0, _abstractValidator2.default)(function (val) {
	// Try to convert the value to a JSON object.
	try {
		val = JSON.parse(val);
	} catch (e) {}

	if ((0, _utilities.isDefined)(val) && !(0, _utilities.isObject)(val)) {
		return new Error('The value is optional, but must be a "Object", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return val;
});

},{"./abstractRequiredValidator.js":1,"./abstractValidator.js":2,"./any.js":3,"./utilities/":12}],8:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isOptional = exports.isRequired = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _abstractRequiredValidator = _dereq_('./abstractRequiredValidator.js');

var _abstractRequiredValidator2 = _interopRequireDefault(_abstractRequiredValidator);

var _abstractValidator = _dereq_('./abstractValidator.js');

var _abstractValidator2 = _interopRequireDefault(_abstractValidator);

var _utilities = _dereq_('./utilities/');

var _any = _dereq_('./any.js');

var any = _interopRequireWildcard(_any);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extends the general required validator for the type `String`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an Error of the passed value if defined.
 *
 */
var isRequired = exports.isRequired = (0, _abstractRequiredValidator2.default)(function (val) {
	var isValueNotValidString = !(0, _utilities.isString)(val);

	if (isValueNotValidString) {
		return new Error('The value is required and must be a "String", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return val;
});

/**
 * Extends the general optional validator for the type `String`.
 *
 * @param val {*} The value which will be validated.
 * @returns {Error|*} Either an error or the value which was passed to the validator.
 *
 */
var isOptional = exports.isOptional = (0, _abstractValidator2.default)(function (val) {
	var isValueNoString = !(0, _utilities.isString)(val);

	if ((0, _utilities.isDefined)(val) && isValueNoString) {
		return new Error('The value is optional, but must be a "String", instead got "' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '".');
	}

	return (0, _utilities.isDefined)(val) ? val : undefined;
});

},{"./abstractRequiredValidator.js":1,"./abstractValidator.js":2,"./any.js":3,"./utilities/":12}],9:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combinePropTypes = undefined;

var _isError = _dereq_('./isError');

/**
 * Combines several propTypes. The first one that returns an error will
 * end the execution chain.
 *
 * @param ...propTypes {...Function} The propTypes that will be combined
 * @returns {Function}
 *
 */
var combinePropTypes = exports.combinePropTypes = function combinePropTypes() {
  for (var _len = arguments.length, propTypes = Array(_len), _key = 0; _key < _len; _key++) {
    propTypes[_key] = arguments[_key];
  }

  return function (props, propName) {
    for (var i = 0, len = propTypes.length - 1; i < len; i++) {
      var validationResult = propTypes[i](props, propName);
      if ((0, _isError.isError)(validationResult)) {
        return validationResult;
      }
    }

    return propTypes[propTypes.length - 1](props, propName);
  };
};

},{"./isError":16}],10:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Compose various functions.
 *
 * @param ...funcs {...Function} The functions that will be composed
 * @returns {Function}
 *
 */
var compose = exports.compose = function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function (arg) {
    return funcs.reverse().reduce(function (currentValue, nextFunction) {
      return nextFunction(currentValue);
    }, arg);
  };
};

},{}],11:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.convertStringBoolean = convertStringBoolean;
/**
 * Converts a string containing a boolean to a real boolean if necessary.
 *
 * @param val
 * @returns {*}
 *
 */
function convertStringBoolean(val) {
	if (val === 'false') {
		val = false;
	}

	if (val === 'true') {
		val = true;
	}

	return val;
}

},{}],12:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isString = exports.isObject = exports.isNumeric = exports.isFunction = exports.isError = exports.isDefined = exports.isBoolean = exports.isArray = exports.convertStringBoolean = exports.compose = exports.combinePropTypes = undefined;

var _combinePropTypes = _dereq_('./combinePropTypes.js');

var _compose = _dereq_('./compose.js');

var _convertStringBoolean = _dereq_('./convertStringBoolean.js');

var _isArray = _dereq_('./isArray.js');

var _isBoolean = _dereq_('./isBoolean.js');

var _isDefined = _dereq_('./isDefined.js');

var _isError = _dereq_('./isError.js');

var _isFunction = _dereq_('./isFunction.js');

var _isNumeric = _dereq_('./isNumeric.js');

var _isObject = _dereq_('./isObject.js');

var _isString = _dereq_('./isString.js');

exports.combinePropTypes = _combinePropTypes.combinePropTypes;
exports.compose = _compose.compose;
exports.convertStringBoolean = _convertStringBoolean.convertStringBoolean;
exports.isArray = _isArray.isArray;
exports.isBoolean = _isBoolean.isBoolean;
exports.isDefined = _isDefined.isDefined;
exports.isError = _isError.isError;
exports.isFunction = _isFunction.isFunction;
exports.isNumeric = _isNumeric.isNumeric;
exports.isObject = _isObject.isObject;
exports.isString = _isString.isString;

},{"./combinePropTypes.js":9,"./compose.js":10,"./convertStringBoolean.js":11,"./isArray.js":13,"./isBoolean.js":14,"./isDefined.js":15,"./isError.js":16,"./isFunction.js":17,"./isNumeric.js":18,"./isObject.js":19,"./isString.js":20}],13:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.isArray = isArray;
/**
 * Checks if the given argument is an array.
 *
 * @param arr {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isArray(arr) {
  return arr !== null && (typeof arr === 'undefined' ? 'undefined' : _typeof(arr)) === 'object' && Array.isArray(arr);
}

},{}],14:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBoolean = isBoolean;
/**
 * Checks if the given argument is a boolean or a string containing a boolean.
 *
 * @param bol {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isBoolean(bol) {
  return typeof bol === 'boolean' || bol === 'true' || bol === 'false';
}

},{}],15:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefined = isDefined;
/**
 * Checks if the given argument is defined and not `null`.
 *
 * @param val {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isDefined(val) {
  return val !== null && val !== undefined;
}

},{}],16:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isError = isError;
/**
 * Checks if the given argument is an instance of the Error Object.
 *
 * @param val {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isError(val) {
  return val instanceof Error;
}

},{}],17:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = isFunction;
/**
 * Checks if the given argument is a function.
 *
 * @param func {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isFunction(func) {
  return typeof func === 'function';
}

},{}],18:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumeric = isNumeric;
/**
 * Checks if the given argument is a Number.
 *
 * @param num {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isNumeric(num) {
  return !isNaN(num) && num !== null && num !== true && num !== false;
}

},{}],19:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.isObject = isObject;
/**
 * Checks if the given argument is a object.
 *
 * @param obj {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isObject(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null;
}

},{}],20:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isString = isString;
/**
 * Checks if the given argument is a string.
 *
 * @param str {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isString(str) {
  return typeof str === 'string';
}

},{}]},{},[5])(5)
});